import React from "react";
import { Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import { Box } from "@mui/system";

function PatientSummary(props: any) {
  const navigate = useNavigate();
  const { id } = props;

  return (
    <>
      <Box sx={{ p: 8, width: "100%", textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          Patient has been added successfully. You can edit the new Patient or go to Patient's page.
        </Typography>
        <Box style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }} sx={{ mt: 4 }}>    
        <Button color="secondary" onClick={() => navigate(`/patient/${id}/user`)}>
            Edit New Patient
          </Button>
          <Button color="secondary" onClick={() => navigate("/patients")}>
            Go To Patients
          </Button>          
        </Box>  
      </Box>
    </>
  );
}

export default PatientSummary;
